export default class CookieBanner {
  /**
   * Constructor
   *
   * @returns {void}
   */
  constructor() {
    // Set scope
    const scope = document.body;

    this.boundAcceptCookies = (e) => this.acceptCookies(e);
    this.boundRefuseCookies = (e) => this.refuseCookies(e);
    this.boundSaveCookies = (e) => this.saveCookies(e);

    // Get elements
    this.cookieBanner = scope.querySelector(".cookie-banner");
    this.acceptCookiesButton = scope.querySelector(".accept-cookies-button");
    this.refuseCookiesButton = scope.querySelector(".refuse-cookies-button");
    this.saveCookiesButton = scope.querySelector(".save-cookies-button");

    this.cookieOverlay = scope.querySelector(".cookie-overlay");
    this.openOverlayButton = scope.querySelector(".open-overlay-button");
    this.closeOverlayButton = scope.querySelector(".close-overlay-button");
    this.marketingCheckbox = scope.querySelector(".marketing-checkbox");

    this.init();
  }

  init() {
    if (!this.cookieBanner) return; // Return when the cookie banner is not present

    const hasSetCookies = getCookie("hasSetCookies") === "accepted";

    if (!hasSetCookies) {
      this.cookieBanner.classList.toggle("d-none"); // Enable the cookie banner if the user had accepted the cookies
      setCookie("acceptedCookies", limited, 31);
    }

    this.acceptCookiesButton.addEventListener(
      "click",
      this.boundAcceptCookies,
      true,
    );

    this.refuseCookiesButton.addEventListener(
      "click",
      this.boundRefuseCookies,
      true,
    );

    this.saveCookiesButton.addEventListener(
      "click",
      this.boundSaveCookies,
      true,
    );

    this.openOverlayButton.addEventListener(
      "click",
      () => this.cookieOverlay.classList.toggle("show"),
      true,
    );

    this.closeOverlayButton.addEventListener(
      "click",
      () => this.cookieOverlay.classList.toggle("show"),
      true,
    );
  }

  acceptCookies(e) {
    e.preventDefault();

    setCookie("hasSetCookies", "accepted", 31);
    setCookie("acceptedCookies", "marketing", 31);

    location.reload();
  }

  refuseCookies(e) {
    e.preventDefault();

    setCookie("hasSetCookies", "accepted", 31);
    setCookie("acceptedCookies", "limited", 31);

    location.reload();
  }

  saveCookies(e) {
    e.preventDefault();

    this.marketingCheckbox.checked
      ? this.acceptCookies(e)
      : this.refuseCookies(e);

    location.reload();
  }
}

function setCookie(name, value, expireDays) {
  const date = new Date();
  date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(cookieName) {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const allCookies = decodedCookie.split(";");
  const allCookiesLength = allCookies.length;

  for (let i = 0; i < allCookiesLength; i += 1) {
    let cookie = allCookies[i];

    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return "";
}
